<template>
  <portal to="modalPortal" v-if="modalName === activeModal">
    <div class="modal" :class="{'is-active': modalName === activeModal}" :id="modalName">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-content" :style="{overflow: 'visible'}">
        <div class="modal-card" :style="{width: width, height: height, overflow: 'visible'}">
          <header v-if="title">
            <div class="app-modal-header">
              <div class="modal-columns-custo">
                <h2 class="has-text-left">
                  <button v-if="toggleBackButton" class="modal-back-button" @click="toggleBackButton">{{ $t('global.button_back_overview') }}
                  </button>
                </h2>
                <h2 class="has-text-centered">{{ $t(title) }}</h2>
                <h2 class="has-text-right modal-header-right-custo">{{ rightText }}</h2>
              </div>
            </div>
          </header>
          <section class="modal-card-body">

            <!-- Content ... -->
            <slot></slot>
          </section>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="closeModal"/>
    </div>
  </portal>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Modal',
  props: {
    modalName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false
    },
    height: {
      type: String,
      required: false
    },
    rightText: {
      type: String,
      required: false
    },
    toggleBackButton: {
      required: false
    }
  },
  computed: {
    ...mapState('appStore', ['modalComponent']),
    activeModal () {
      return this.modalComponent
    }
  },
  methods: {
    ...mapActions('appStore', ['closeModal'])
  },
  beforeDestroy() {
    if (this.activeModal === this.modalName) {
      // Re-enable background scroll if it has not been already done.
      this.closeModal(); 
    }
  }
}
</script>

<style lang="scss">

.modal-columns-custo {
    display: flex;
    justify-content: space-between;
}

.modal-header-right-custo {
  margin-right: 5px;
}

.modal-back-button {
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
  color: black;
  margin-left: 5px;
}

.modal-back-button:hover {
  background-color: #e2e6ea;
}

</style>
